export default __webpack_public_path__ + "assets/images/c9e792f9c267476b5a8ccdd4365f67e8.png";